import { render, staticRenderFns } from "./InvoicesType.vue?vue&type=template&id=210f044c&scoped=true"
import script from "./InvoicesType.vue?vue&type=script&lang=js"
export * from "./InvoicesType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f044c",
  null
  
)

export default component.exports